export const isLinkedInAvatar = (avatar: string | null | undefined): boolean => {
  if (!avatar) return false;
  try {
    const host = new URL(avatar).hostname.toLowerCase();
    return host === 'media.licdn.com' || host.endsWith('.licdn.com') || host.endsWith('.linkedin.com');
  } catch {
    return avatar.toLowerCase().includes('licdn.com');
  }
};

export const tokenIdentityProvider = (token: string | null | undefined): string | null => {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1])) as {
      identity_provider?: unknown;
      avatar?: unknown;
    };
    if (typeof payload.identity_provider === 'string' && payload.identity_provider) {
      return payload.identity_provider;
    }
    const avatar = typeof payload.avatar === 'string' ? payload.avatar : null;
    return isLinkedInAvatar(avatar) ? 'linkedin' : null;
  } catch {
    return null;
  }
};